import { RECRUITERCLIENTMATCHINGJOBS } from "../../ENVIRONMENT";

// api for recruiter candidate details
async function reccandidateDetails(token, id) {
  const response = await fetch(RECRUITERCLIENTMATCHINGJOBS + `/${id}`, {
    headers: {
      "Content-Type": "Application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
  return response;
}

export { reccandidateDetails };
